import { Package, Home } from "lucide-react";

const input = "w-full rounded-xl border border-[#DADADA] bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-accent transition-colors";
const label = "text-xs font-semibold text-foreground block mb-1.5";

export const emptyAddress = {
  mode: "address", first_name: "", last_name: "", street: "", house_no: "",
  zip: "", city: "", country: "Deutschland", post_number: "", station_number: "",
};

export function addressComplete(a) {
  if (!a.first_name || !a.last_name || !a.zip || !a.city) return false;
  if (a.mode === "packstation") {
    return /^\d{6,10}$/.test(a.post_number) && /^\d{3}$/.test(a.station_number) && /^\d{5}$/.test(a.zip);
  }
  return !!(a.street && a.house_no);
}

export function buildShippingAddress(a) {
  const name = `${a.first_name} ${a.last_name}`.trim();
  if (a.mode === "packstation") {
    return { type: "packstation", name, post_number: a.post_number, station_number: a.station_number, zip: a.zip, city: a.city, country: "Deutschland" };
  }
  return { type: "address", name, street: `${a.street} ${a.house_no}`.trim(), zip: a.zip, city: a.city, country: a.country };
}

export function AddressForm({ value, onChange, packstationEnabled = true }) {
  const a = value;
  const set = (k) => (e) => onChange({ ...a, [k]: e.target.value });
  const setMode = (mode) => onChange({ ...a, mode, ...(mode === "packstation" ? { country: "Deutschland" } : {}) });

  return (
    <div>
      {packstationEnabled && (
        <div className="grid grid-cols-2 gap-2 mb-4" data-testid="delivery-mode-switch">
          <button type="button" data-testid="delivery-mode-address" onClick={() => setMode("address")}
            className={`rounded-xl border py-2.5 text-sm font-semibold flex items-center justify-center gap-2 transition-colors ${a.mode === "address" ? "border-accent bg-accent/5 text-accent" : "border-border hover:border-foreground/30"}`}>
            <Home className="w-4 h-4" /> Lieferadresse
          </button>
          <button type="button" data-testid="delivery-mode-packstation" onClick={() => setMode("packstation")}
            className={`rounded-xl border py-2.5 text-sm font-semibold flex items-center justify-center gap-2 transition-colors ${a.mode === "packstation" ? "border-accent bg-accent/5 text-accent" : "border-border hover:border-foreground/30"}`}>
            <Package className="w-4 h-4" /> DHL Packstation
          </button>
        </div>
      )}
      <div className="grid grid-cols-2 gap-3">
        <div><label className={label}>Vorname</label><input data-testid="checkout-first-name" className={input} value={a.first_name} onChange={set("first_name")} required /></div>
        <div><label className={label}>Nachname</label><input data-testid="checkout-last-name" className={input} value={a.last_name} onChange={set("last_name")} required /></div>
        {a.mode === "packstation" ? (
          <>
            <div><label className={label}>Postnummer (6–10 Ziffern)</label><input data-testid="checkout-post-number" className={input} inputMode="numeric" placeholder="z. B. 12345678" value={a.post_number} onChange={set("post_number")} required /></div>
            <div><label className={label}>Packstation-Nr. (3 Ziffern)</label><input data-testid="checkout-station-number" className={input} inputMode="numeric" placeholder="z. B. 123" value={a.station_number} onChange={set("station_number")} required /></div>
            <div><label className={label}>PLZ</label><input data-testid="checkout-zip" className={input} inputMode="numeric" value={a.zip} onChange={set("zip")} required /></div>
            <div><label className={label}>Ort</label><input data-testid="checkout-city" className={input} value={a.city} onChange={set("city")} required /></div>
            <p className="col-span-2 text-[11px] text-muted-foreground bg-secondary border border-border rounded-xl p-3" data-testid="packstation-note">
              Lieferung an DHL Packstationen ist nur innerhalb Deutschlands möglich. Deine Postnummer findest du in der DHL-App. Die Angaben werden vom Versanddienstleister bei der Zustellung geprüft.
            </p>
          </>
        ) : (
          <>
            <div className="col-span-2 grid grid-cols-3 gap-3">
              <div className="col-span-2"><label className={label}>Straße</label><input data-testid="checkout-street" className={input} value={a.street} onChange={set("street")} required /></div>
              <div><label className={label}>Hausnummer</label><input data-testid="checkout-house-no" className={input} value={a.house_no} onChange={set("house_no")} required /></div>
            </div>
            <div><label className={label}>PLZ</label><input data-testid="checkout-zip" className={input} value={a.zip} onChange={set("zip")} required /></div>
            <div><label className={label}>Ort</label><input data-testid="checkout-city" className={input} value={a.city} onChange={set("city")} required /></div>
            <div className="col-span-2"><label className={label}>Land</label>
              <select data-testid="checkout-country" className={input} value={a.country} onChange={set("country")}>
                <option>Deutschland</option><option>Österreich</option><option>Schweiz</option>
              </select>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
